var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EB5757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0363 12.4526L17.3229 8.16601C17.4883 8.00623 17.4929 7.74259 17.3331 7.57715C17.1733 7.4117 16.9097 7.40712 16.7443 7.5669C16.7408 7.57024 16.7374 7.57366 16.734 7.57715L12.4474 11.8637L8.16077 7.57712C7.99533 7.41734 7.73169 7.42193 7.57191 7.58737C7.41603 7.74877 7.41603 8.00462 7.57191 8.16601L11.8585 12.4526L7.57191 16.7392C7.40932 16.9018 7.40932 17.1655 7.57191 17.3281C7.73452 17.4906 7.99816 17.4906 8.16077 17.3281L12.4474 13.0415L16.734 17.3281C16.8994 17.4879 17.1631 17.4833 17.3229 17.3178C17.4787 17.1564 17.4787 16.9006 17.3229 16.7392L13.0363 12.4526Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4318 7.24305C16.776 6.91078 17.3244 6.92038 17.6568 7.26454C17.9882 7.60765 17.9798 8.15377 17.6388 8.48652L13.6727 12.4526L17.6466 16.4265C17.9709 16.7623 17.9708 17.2947 17.6466 17.6304C17.3141 17.9746 16.7656 17.9842 16.4214 17.6518L16.4157 17.6463L12.4474 13.6779L8.47897 17.6463C8.14063 17.9845 7.5921 17.9846 7.25376 17.6463C6.91546 17.308 6.91539 16.7594 7.25368 16.421L11.2221 12.4526L7.24818 8.47868C6.92387 8.1429 6.92392 7.61054 7.24822 7.27476M16.4318 7.24305C16.4257 7.24898 16.4195 7.25516 16.4135 7.26126L12.4474 11.2274L8.47897 7.25893L8.47338 7.25344C8.12918 6.92101 7.58066 6.93055 7.24822 7.27476",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCheckIcon);
export default __webpack_public_path__ + "static/media/unCheckIcon.072d0a72f95aa51174a8658847fdae94.svg";
export { ForwardRef as ReactComponent };